import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../theme/colors';

export const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 24,
  },

  headers: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  headerItem: {
    fontWeight: 800,
    fontSize: 11,
    color: colors.neutral900,
    lineHeight: '1.3px',
  },

  headerItems: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    borderBottom: `1px solid ${colors.neutral}`,
    height: 30,
    minHeight: 30,
    width: '100%',
  },

  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderBottom: `1px solid ${colors.neutral200}`,
    height: 41,
  },

  cell: {
    fontSize: 11,
    marginTop: 12,
    color: colors.neutral700,
    fontWeight: 400,
    height: 30,
    lineHeight: '1.3px',
  },

  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },

  tableTitle: {
    fontWeight: 600,
    fontSize: 14,
    color: colors.neutral900,
    marginBottom: 10,
  },
  note: {
    fontWeight: 700,
    fontSize: 10,
    textTransform: 'uppercase',
    marginTop: 10,
    color: colors.neutral900,
  },

  text: {
    fontWeight: 400,
    fontSize: 11,
    lineHeight: '1.8px',
    color: colors.neutral900,
  },
});
